export default {
  VerifyModal: {
    title: "Подтвердите учётную запись",
    send: "Отправить на проверку",
    step1: {
      reason:
        "Сервис создан исключительно для медицинских специалистов, поэтому доступ к некоторым функциям ограничен только для подтвержденных пользователей. Это позволяет:",
      reasons: {
        1: "Исключить доступ пациентов и посторонних лиц",
        2: "Гарантировать профессиональное сообщество для обмена знаниями и опытом",
        3: "Соблюдать медицинскую этику и стандарты работы с данными",
      },
      end: "Мы ценим вашу безопасность и конфиденциальность. Вся информация используется только для проверки вашего статуса и удаляется после завершения процесса.",
      status: "Статус",
      statuses: {
        doctor: "Врач",
        student: "Студент",
        ordinator: "Ординатор",
      },
    },
    step2: {
      agenda:
        "Все предоставленные данные защищены и используются исключительно для проверки вашего статуса.",
      chooseVerifyWay: "Выберите способ подтверждения",
      ways: {
        1: "Диплом, сертификат или удостоверение",
        2: "Ссылка на свою подтвержденную страницу на медицинском агрегаторе (Продокторов, DocDoc и др.)",
        3: "Ссылка на свою страницу на сайте клиники",
        4: "Загрузите диплом о медицинском образовании",
        5: "Загрузите студенческий билет медицинского вуза",
      },
      selectFile: "Выберите файл",
      sendToCheck: "Отправить на проверку",
      pasteLink: "Вставьте ссылку",
      notAllowedFile: "Допустимы только PDF и изображения.",
      noMoreFiles: "Максимальное количество файлов - ",
    },
    step3: {
      processing: {
        title: "Документ отправлен на проверку",
        text1_1:
          "Мы проверим ваши данные, после этого вы получите уведомление на почту ",
        text1_2: "",
        text2: "Проверка занимает один рабочий день.",
      },
      rejected: {
        title: "Учетная запись не подтверждена",
        text1_1:
          "Ваши данные не прошли проверку. Пожалуйста, отправьте корректные данные. Это необходимо для получения доступа к загрузке и обработке исследований искусственным интеллектом",
        text1_2: "Попробовать снова",
      },
    },
  },
};
